import { Button } from '@akin-home/buttons/native';
import { spacing } from '@akin-home/theme';
import React, { useState } from 'react';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import TextInput from '../../../components/TextInput';

type RobotDirectConnectInputProps = {
  onSubmit?: (ipAddress: string) => void;
  containerStyle?: StyleProp<ViewStyle>;
  textInputStyle?: StyleProp<TextStyle>;
  buttonStyle?: StyleProp<ViewStyle>;
  buttonSize?: number;
  initialIp?: string;
};

export const RobotDirectConnectInput = (
  props: RobotDirectConnectInputProps
) => {
  const [ipInput, setIPInput] = useState<string>(props.initialIp ?? '');
  const onChangeIPInput = (text: string) => {
    setIPInput(text);
  };

  return (
    <View style={[styles.container, props.containerStyle]}>
      <TextInput
        placeholder="IP Address (e.g., 192.168.1.2:8000)"
        value={ipInput}
        onChangeText={onChangeIPInput}
        style={[styles.textInputStyle, props.textInputStyle]}
      />

      <Button
        variant="secondary"
        icon="search"
        iconSize={props.buttonSize ?? 20}
        onPress={() => {
          props.onSubmit?.(ipInput ?? '');
        }}
        style={[styles.buttonStyle, props.buttonStyle]}
      >
        {'Find'}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: spacing[3],
  },
  textInputStyle: {
    flex: 1,
    marginRight: spacing[1],
  },
  buttonStyle: {
    height: '100%',
    alignSelf: 'center',
  },
});
